import { BorrowUsdcViaUsdsBanner } from '../../components/borrow-usdc-via-usds-banner/BorrowUsdcViaUsdsBanner'
import { InterestRateModelPanel } from '../../components/interest-rate-model-panel/InterestRateModelPanel'
import { MarketOverview as MarketOverviewPanel } from '../../components/market-overview/MarketOverview'
import { MyWalletPanel } from '../../components/my-wallet/MyWalletPanel'
import { OraclePanel } from '../../components/oracle-panel/OraclePanel'
import { BorrowStatusPanel } from '../../components/status-panel/BorrowStatusPanel'
import { CollateralStatusPanel } from '../../components/status-panel/CollateralStatusPanel'
import { EModeStatusPanel } from '../../components/status-panel/EModeStatusPanel'
import { SupplyStatusPanel } from '../../components/status-panel/SupplyStatusPanel'
import { MarketDetailsViewProps } from '../types'
import { BackNav } from './BackNav'
import { Header } from './Header'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { cn } from '@/ui/utils/style'

export function FullView({
  token,
  aToken,
  variableDebtTokenAddress,
  chainId,
  chainName,
  chainMismatch,
  marketOverview,
  walletOverview,
  openConnectModal,
  openSandboxModal,
  oracleInfo,
  interestRateModel,
  sllManaged,
  swapAvailable,
  usdcViaUsdsProxyMarket,
  className,
}: MarketDetailsViewProps) {
  return (
    <PageLayout className={cn('gap-0', className)}>
      <BackNav chainId={chainId} />
      <Header
        token={token}
        aToken={aToken}
        variableDebtTokenAddress={variableDebtTokenAddress}
        chainName={chainName}
        chainMismatch={chainMismatch}
        chainId={chainId}
        sllManaged={sllManaged}
        swapAvailable={swapAvailable}
        isUsdcViaUsdsProxyMarket={usdcViaUsdsProxyMarket?.selected ?? false}
      />
      <div className="grid grid-cols-[2fr_1fr] gap-5 md:gap-10">
        <div className="flex flex-col gap-6">
          {usdcViaUsdsProxyMarket?.showBorrowFromProxyMarketBanner && (
            <BorrowUsdcViaUsdsBanner link={usdcViaUsdsProxyMarket.link} />
          )}
          {marketOverview.supply && <SupplyStatusPanel token={token} {...marketOverview.supply} />}
          <CollateralStatusPanel {...marketOverview.collateral} />
          {marketOverview.eMode && <EModeStatusPanel {...marketOverview.eMode} />}
          <BorrowStatusPanel token={token} {...marketOverview.borrow} />
          {interestRateModel && <InterestRateModelPanel {...interestRateModel} />}
          <OraclePanel {...oracleInfo} />
        </div>
        <div className="flex flex-col gap-6">
          {(marketOverview.borrow.status === 'no' ? !marketOverview.summary.borrowed.isZero() : true) && (
            <MarketOverviewPanel token={token} {...marketOverview.summary} />
          )}
          <MyWalletPanel
            openSandboxModal={openSandboxModal}
            walletOverview={walletOverview}
            openConnectModal={openConnectModal}
            chainMismatch={chainMismatch}
          />
        </div>
      </div>
    </PageLayout>
  )
}
